export default __webpack_public_path__ + "static/media/background-cover-auth-signin.97701ca5.png";